<template>
  <!--  Fixme 宽度超出浏览器会出现显示错误-->
  <v-menu
    offset-y
    full-width
    :max-width="Math.min((depth * selectWidth), maxWidthNumber)"
    :close-on-content-click="false"
    :disabled="readonly || disabled"
    lazy
    v-model="menu"
  >
    <v-text-field
      slot="activator"
      v-bind="$attrs"
      readonly
      :disabled="disabled"
      :value="selectFormatted"
      clearable
      @click:clear="clearInput"
    ></v-text-field>
    <v-card style="overflow: auto" :max-height="maxHeight">
      <v-layout>
        <template v-for="(level, i) in showLevels">
          <v-card :key="i" flat tile :max-width="selectWidth + 'px'" :min-width="selectWidth + 'px'">
            <v-list :dense="dense" :style="{maxHeight:maxHeight, overflow: 'auto'}">
              <v-list-tile v-if="noItem">
                <v-list-tile-title class="grey--text text-xs-center">{{noDataText}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @mouseenter="onHover(item, i)" @click="onSelect(item, i)" v-for="(item, j) in level"
                           :key="j">
                <v-list-tile-content>
                  <v-list-tile-title
                    :class="isSelect(item, i) ? 'primary--text':''"
                  >{{item[itemText]}}
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="haveChildren(item)">
                  <v-icon small>$vuetify.icons.chevronRight</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
          <v-divider :key="i + 'd'" v-if="i !== showLevels.length - 1" vertical></v-divider>
        </template>
      </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
// TODO 优化点
function DFS (items, equal, childrenName) {
  return _DFS(items, equal, childrenName, [])
}

function _DFS (items, equal, childrenName, indexes) {
  let t = items.find(equal)
  if (t) {
    indexes.push(items.indexOf(t))
    return indexes
  }
  else {
    for (let i = 0; i < items.length; ++i) {
      let children = items[i][childrenName]
      if (children) {
        let res = _DFS(children, equal, childrenName, [...indexes, i])
        if (res.length) {
          return res
        }
      }
    }
  }
  return []
}

export default {
  name: 'LCascader',
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: '没有数据'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemChildren: {
      type: String,
      default: 'children'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    contentWidth: {
      type: [String, Number],
      default: 150
    },
    items: {
      type: Array,
      default: () => []
    },
    maxWidth: {},
    maxHeight: {default: '400px'},
    readonly: {},
    disabled: {},
    value: {},
    seq: {
      type: String,
      default: '/'
    },
    onlyLast: {
      type: Boolean,
      default: true
    },
   /* hidePrev: {
      type: Boolean,
      default: false
    }*/
  },
  data: () => ({
    levels: [],
    selected: [],
    indexes: [],
    menu: false,
    hidePrev:false
  }),
  computed: {
    showLevels () {
      if (this.hidePrev) {
        let item = this.levels[this.levels.length - 1]
        return item?[item]:[]
      }
      else {
        return this.levels
      }
    },
    maxWidthNumber () {
      let n = this.getNumber(this.maxWidth)
      return isNaN(n) ? Infinity : n
    },
    noItem () {
      return this.items.length === 0
    },
    depth () {
      // 展示的深度
      return this.showLevels.length
    },
    selectWidth () {
      return this.getNumber(this.contentWidth) || 150
    },
    noChildren () {
      return (item) => !this.haveChildren(item)
    },
    haveChildren () {
      return (item) => item && item[this.itemChildren] && item[this.itemChildren].length > 0
    },
    isSelect () {
      return (item, level) => {
        let name = this.itemValue
        return this.selected[level] && item[name] === this.selected[level][name]
      }
    },
    selectFormatted () {
      let selected = []
      let items = this.items
      for (let idx of this.indexes) {
        if (items[idx]) {
          selected.push(items[idx])
          items = items[idx][this.itemChildren]
        }
        else {
          break
        }
      }
      if (this.onlyLast) {
        let last = selected[selected.length - 1]
        if (this.noChildren(last)) {
          return selected.map(s => s[this.itemText]).join(this.seq)
        }
      }
      else {
        return selected.map(s => s[this.itemText]).join(this.seq)
      }
      return ''
    }
  },
  watch: {
    value (val) {
      if (!(val instanceof Object)) return
      this.syncValue()
    },
    items: {
      deep: true,
      handler () {
        this.syncValue()
      }
    },
    menu (val) {
      if (!val) {
        // 仅同步value，不执行DFS
        this.syncValue(false)
      }
    }
  },
  methods: {
    // 将value的值同步到selected，dfs搜索，重置selected和levels
    syncValue (dfs = true) {
      let val = this.value
      if (!val) {
        this.levels = [this.items]
        this.selected = []
        this.indexes = []
        return
      }
      // if (this.onlyLast) {
      //   if (this.noChildren(val)) {
      if (dfs) {
        // DFS得到值的路径，如果未搜索到返回空数组
        this.indexes = DFS(this.items, v => v[this.itemValue] === val[this.itemValue], this.itemChildren)
      }

      // 重置值
      this.levels = [this.items]
      this.selected = []

      this.indexes.forEach((idx, i) => {
        this.selected[i] = this.levels[i][idx]
        // 如果不是最后，填充下一个level，正常情况下一定有children
        if (i !== this.indexes.length - 1) {
          let children = this.selected[i][this.itemChildren] || []
          this.levels.push(children)
        }
      })

      // 是否需要展示下一层
      let last = this.selected[this.selected.length - 1]
      if (this.haveChildren(last)) {
        this.$set(this.levels, this.levels.length, last[this.itemChildren])
      }
    },
    // 将selected值同步到value
    emitValue () {
      let last = this.selected[this.selected.length - 1]
      this.$emit('input', last || null)
    },
    getNumber (text) {
      let group = /(\d+)/i.exec(text + '')
      if (group && group[1]) {
        return Number(group[1])
      }
    },
    clearInput () {
      this.selected = []
      this.levels = [this.items]
      this.menu = false
      this.emitValue()
    },
    // 用户鼠标悬浮，只展开，不同步值
    onHover (item, currentLevel) {
      if (!this.onlyLast) return
      let s = this.selected[currentLevel] || {} // 点击之前被选中的
      let v = this.itemValue

      // 值有变化,并且不是叶子结点，之后所有层清空重选
      // 不是叶子结点，自动展开下一层，是叶子结点，隐藏下一级，不更新值，等待用户点击
      if (item[v] !== s[v]) {
        this.$set(this.selected, currentLevel, item)
        // 如果可以选择非叶子结点，提交
        while (this.levels.length !== currentLevel + 1) {
          this.levels.pop()
        }
        while (this.selected.length !== currentLevel + 1) {
          this.selected.pop()
        }
        if (this.haveChildren(item)) {
          this.$set(this.levels, currentLevel + 1, item[this.itemChildren])
        }
      }
    },
    // 用户点击
    onSelect (item, currentLevel) {
      // let s = this.selected[currentLevel] || {} // 点击之前被选中的
      // let v = this.itemValue

      // 无论值有无变化,均将之后所有层清空重选，并更新value
      // if (item[v] !== s[v]) {
      this.$set(this.selected, currentLevel, item)
      // 如果可以选择非叶子结点，提交
      if (!this.onlyLast) {
        this.emitValue()
      }
      while (this.levels.length !== currentLevel + 1) {
        this.levels.pop()
      }
      while (this.selected.length !== currentLevel + 1) {
        this.selected.pop()
      }
      // }
      // 需要展示下一层
      if (this.haveChildren(item)) {
        this.$set(this.levels, currentLevel + 1, item[this.itemChildren])
      }
      else {
        // 到叶子节点，选择完毕
        this.menu = false
        this.emitValue()
      }
    }
  },
  created () {
    this.syncValue()
  }
}
</script>

<style scoped>

</style>
